export default {
    namespaced: true,

    state: {
        removeDialog: false,
        group: null,
        parent: null,
        accounts: []
    },

    getters: {
        removeDialog: state => state.removeDialog,
        group: state => state.group,
        parent: state => state.parent,
        accounts: state => state.accounts,
        groupBalanceId: () => 'group-balance-zero',
        groupPivotCode: () => 9998
    },

    mutations: {
        show(state, data) {
            state.removeDialog = true
            state.group = data.group
            state.parent = data.parent
            state.accounts = data.accounts
        },

        hide(state) {
            state.removeDialog = false
            state.group = null
            state.parent = null
            state.accounts = []
        }
    }
}
